export interface RequestContext {
  requestId: string;
  traceId?: string;
  spanId?: string;
}

export interface RequestContextProvider {
  run<T>(ctx: RequestContext, fn: () => T): T;
  get(): RequestContext | undefined;
}

const noopProvider: RequestContextProvider = {
  run<T>(_ctx: RequestContext, fn: () => T): T {
    return fn();
  },
  get(): RequestContext | undefined {
    return undefined;
  },
};

let provider: RequestContextProvider = noopProvider;

export function setRequestContextProvider(p: RequestContextProvider): void {
  provider = p;
}

export function runWithContext<T>(ctx: RequestContext, fn: () => T): T {
  return provider.run(ctx, fn);
}

export function getContext(): RequestContext | undefined {
  return provider.get();
}
